import React, { Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { validate, renderMaterialField, renderCleaveMaterialField } from '../../../helpers/formHelper';
import { paxLogo, paxStatus } from '../../../helpers/passengerHelper';
import PassengerBar from './passengerbar';

const submit = (values) => {
    //console.log("DISPATCHED FROM PAYMENT PROCESSING - ", values);
}

let PassengerItem = props => {
  const { handleSubmit } = props;

  return (
    <Fragment>
    <PassengerBar title={props.paxName} status={paxStatus(props)} icon={paxLogo(props)} barClass="secondaryPax" />
      <div className="confirm-modal-wrapper">
        <form className="passenger-item" data-id={props.index} onSubmit={handleSubmit}>
          <div className="row">
            <div className="column small-12 medium-6 col-left-mod">
              <Field name="firstName" fieldId="firstName" component={renderMaterialField} type="text" label="First Name *" />
            </div>

           <div className="column small-12 medium-6 col-right-mod">
              <Field name="surname" fieldId="surname" component={renderMaterialField} type="text" label="Surname *" />
            </div>
         </div>

         <div className="row">
           <div className="column small-12 medium-6 col-left-mod">
             <Field
               name="dob"
               fieldId="dob"
               component={renderCleaveMaterialField}
               type="text"
               label="Date of birth (DD/MM/YYYY) *"
               />
           </div>

           <div className="column small-12 medium-6 col-right-mod">
             <div className="payment-select margin-b-15">
               <div className="gender-options">
                 <div className="column small-6">
                   <div className="radio">
                     <Field component="input" id={`${props.index}male`} name="sex" type="radio" value="male" />
                     <label htmlFor={`${props.index}male`} className="radio-label">Male</label>
                   </div>
                 </div>

                 <div className="column small-6">
                   <div className="radio">
                     <Field component="input" id={`${props.index}female`} name="sex" type="radio" value="female"/>
                     <label htmlFor={`${props.index}female`} className="radio-label">Female</label>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>

       </form>
      </div>
   </Fragment>
  )
}

PassengerItem = reduxForm({
  validate,
  onSubmit:submit,
  destroyOnUnmount: false
})(PassengerItem);

export default PassengerItem;



// WEBPACK FOOTER //
// ./src/components/confirmation/components/passengeritem.js